(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
        $(document).on("submit", "form[data-type='add-to-cart-form']", function(e) {
          e.preventDefault(); // stop redirect / form submit

          var $form = $(this);
          var formData = $form.serialize(); // collect form data (variant id, selling plan etc.)

          // First add the product to cart
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: formData,
            dataType: "json",
            success: function(item) {
              console.log("Added to cart:", item);

              // Then sync the minicart
              $.ajax({
                type: "GET",
                url: "/cart",
                dataType: 'html',
                success: function(data) {
                  console.log("syncCart");

                  var minicartdata = $(data).filter('#slidingcartmain').html();
                  var countget = $(data).find('.cart_count_items').html();

                  // Update / create cart count bubble inside .custom-cart-icon-box
                  if ($('.custom-cart-icon-box .cart_count_items').length) {
                    $('.custom-cart-icon-box .cart_count_items').html(countget);
                  } else {
                    $('.custom-cart-icon-box').prepend(
                      '<span class="cart_count_items">' + countget + '</span>'
                    );
                  }

                  // Update global cart bubble too
                  $('.cart_count_items').html(countget);

                  // Update minicart drawer
                  $('#slidingcartmain').html(minicartdata);

                  // Re-init slider
                  $('.header-cart-related-list').slick({
                    dots: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                  });

                  cart_slider();

                  // Open drawer
                  $("#overlay").addClass("is-active");
                  $(".inline-cart").addClass("is-active");

                  // Hide rewards/chat widgets
                  $("#admin-bar-iframe").css("display", "none");
                  $("#chat-button").css("display", "none");
                }
              });
            },
            error: function(xhr) {
              console.error("Add to cart failed:", xhr.responseText);
            }
          });
        });
        
  } catch(e) { console.error(e); }
})();
})();
